import type { SystemStyleObject } from "@mui/system";
import type { ThemeV2 } from "../../../util/types";

export const questionCardSurface = (theme: ThemeV2): SystemStyleObject => ({
  backgroundColor: theme.tokens.color.surface.card,
  border: `1px solid ${theme.tokens.color.border.default}`,
  borderRadius: `${theme.tokens.shape.radius.md}px`,
  boxShadow: theme.tokens.elevation["1"],
});

export const questionMediaSurface = (theme: ThemeV2): SystemStyleObject => ({
  backgroundColor: theme.tokens.color.surface.card,
  border: `1px solid ${theme.tokens.color.border.default}`,
  borderRadius: `${theme.tokens.shape.radius.lg}px`,
  boxShadow: theme.tokens.elevation["2"],
});
